import { render, staticRenderFns } from "./AirStats.vue?vue&type=template&id=bd519020&scoped=true&"
import script from "./AirStats.vue?vue&type=script&lang=js&"
export * from "./AirStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd519020",
  null
  
)

export default component.exports